import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import 'assets/scss/stage-bar.scss';

type StageBarProps = {
	value: number;
	maxValue: number;
};
export const StageBar = ({ value, maxValue }: StageBarProps) => {
	const current = (value / maxValue) * 100;
	return (
		<div className="stagebar-container">
			<p>
				Paso {value} de {maxValue}
			</p>
			<div style={{ marginTop: '6px' }}>
				<LinearProgress variant="determinate" value={current} color="secondary" />
			</div>
		</div>
	);
};
